export default __webpack_public_path__ + "static/media/flag-thailand.4b571e9b.svg";